<template>
	<div style="padding-top: 10px;padding-bottom: 50px;">
		<h1 style="font-size: 40px;text-align: center;margin-bottom: 25px;margin-top: 8px;">产品首页内容设置</h1>
		<el-descriptions title="第一模块" :column="2" size="40" border :contentStyle="rowCenter" :labelStyle="rowCenter">
			<template slot="extra">
				<el-button type="primary" size="small" @click="eidt(1)">编辑</el-button>
			</template>
			<el-descriptions-item>
				<template slot="label">
					小标题(中文)
				</template>
				{{ firstData[0].content }}
			</el-descriptions-item>
			<el-descriptions-item>
				<template slot="label">
					小标题(英文)
				</template>
				{{ firstData[0].contentEg }}
			</el-descriptions-item>
			<el-descriptions-item>
				<template slot="label">
					标题(中文)
				</template>
				{{ firstData[1].content }}
			</el-descriptions-item>
			<el-descriptions-item>
				<template slot="label">
					标题(英文)
				</template>
				{{ firstData[1].contentEg }}
			</el-descriptions-item>

		</el-descriptions>

		<el-descriptions title="第二模块" style="margin-top: 20px;" :column="2" size="40" border :contentStyle="rowCenter"
			:labelStyle="rowCenter">
			<template slot="extra">
				<el-button type="primary" size="small" @click="eidt(2)">编辑</el-button>
			</template>
			<el-descriptions-item v-for="(item,index) in secondTitle" :key="index">
				<template slot="label">
					{{item.title}}
				</template>
				<el-image v-if="item.contentType == 2" style="width: 50px;height: 50px;" :src="item.content"
					@click="setImage(item.content)" :preview-src-list="secondImageUrl">
				</el-image>
				<span v-else>{{ item.content}} </span>
			</el-descriptions-item>


		</el-descriptions>

		<el-descriptions title="第三模块" style="margin-top: 20px;" :column="2" size="40" border :contentStyle="rowCenter"
			:labelStyle="rowCenter">
			<template slot="extra">
				<el-button type="primary" size="small" @click="eidt(3)">编辑</el-button>
			</template>
			<el-descriptions-item v-for="(item,index) in thirdTitle" :key="index">
				<template slot="label">
					{{item.title}}
				</template>
				<span>{{ item.content}} </span>
			</el-descriptions-item>


		</el-descriptions>
		
		<el-descriptions title="第四模块" style="margin-top: 20px;" :column="2" size="40" border :contentStyle="rowCenter"
			:labelStyle="rowCenter">
			<template slot="extra">
				<el-button type="primary" size="small" @click="eidt(4)">编辑</el-button>
			</template>
			<el-descriptions-item v-for="(item,index) in fourthTitle" :key="index">
				<template slot="label">
					{{item.title}}
				</template>
				<span>{{ item.content}} </span>
			</el-descriptions-item>
		
		</el-descriptions>
		


		<el-dialog title="修改信息" :visible.sync="firstDialogVisible" width="60%" center>
			<el-form ref="form" :model="firstform" label-width="80px">

				<el-form-item label="小标题(中文)" prop="subtitle">
					<el-col :span="20" style="border: 1px solid gray;">
						<!-- <el-input v-model="firstform.title"></el-input> -->
						<tinymce-editor v-model="firstform.sub_title" :init="initEditor" />

					</el-col>
				</el-form-item>

				<el-form-item label="小标题(英文)" prop="subtitle1">
					<el-col :span="20" style="border: 1px solid gray;">
						<!-- <el-input v-model="firstform.title1"></el-input> -->
						<tinymce-editor v-model="firstform.sub_title1" :init="initEditor" />

					</el-col>
				</el-form-item>

				<el-form-item label="标题(中文)" prop="title">
					<el-col :span="20" style="border: 1px solid gray;">
						<!-- <el-input v-model="firstform.content" type="textarea" :rows="8"></el-input> -->
						<tinymce-editor v-model="firstform.title" :init="initEditor" />
					</el-col>
				</el-form-item>

				<el-form-item label="标题(英文)" prop="title1">
					<el-col :span="20" style="border: 1px solid gray;">
						<!-- <el-input v-model="firstform.content1" type="textarea" :rows="8"></el-input> -->
						<tinymce-editor v-model="firstform.title1" :init="initEditor" />
					</el-col>
				</el-form-item>


			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="firstDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="save(1)">{{ btnText }}</el-button>
			</span>
		</el-dialog>

		<el-dialog title="修改信息" :visible.sync="secondDialogVisible" width="60%" center>
			<el-form ref="form" :model="secondform" label-width="80px">

				<div v-for="(item,index) in secondTitle" :key="index">
					<el-form-item :label="item.title" prop="title" label-width="200px;" v-if="item.contentType == 1">
						<el-col :span="15" style="border: 1px solid gray;">
							<!-- <el-input v-model="secondTitle[index].content"></el-input> -->
							<tinymce-editor v-model="secondTitle[index].content" :init="initEditor" />
						</el-col>
					</el-form-item>

				</div>

			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="secondDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="save(2)">{{ btnText }}</el-button>
			</span>
		</el-dialog>

		<el-dialog title="修改信息" :visible.sync="thirdDialogVisible" width="60%" center>
			<el-form ref="form" :model="thirdform" label-width="80px">

				<div v-for="(item,index) in thirdTitle" :key="index">
					<el-form-item :label="item.title" prop="title" label-width="200px;" v-if="item.contentType == 1">
						<el-col :span="15" style="border: 1px solid gray;">
							<!-- <el-input v-model="sixthTitle[index].content"></el-input> -->
							<tinymce-editor v-model="thirdTitle[index].content" :init="initEditor" />
						</el-col>
					</el-form-item>

				</div>

			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="thirdDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="save(3)">{{ btnText }}</el-button>
			</span>
		</el-dialog>

		<el-dialog title="修改信息" :visible.sync="fourthDialogVisible" width="60%" center>
			<el-form ref="form" :model="fourthform" label-width="80px">
		
				<div v-for="(item,index) in fourthTitle" :key="index">
					<el-form-item :label="item.title" prop="title" label-width="200px;" v-if="item.contentType == 1">
						<el-col :span="15" style="border: 1px solid gray;">
							<!-- <el-input v-model="sixthTitle[index].content"></el-input> -->
							<tinymce-editor v-model="fourthTitle[index].content" :init="initEditor" />
						</el-col>
					</el-form-item>
				
				</div>
		
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="fourthDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="save(4)">{{ btnText }}</el-button>
			</span>
		</el-dialog>

	</div>
</template>

<script>
	import TinymceEditor from '../../components/TinymceEditor/index.vue';
	import utils from '../../utils/utils.js'
	export default {
		name: "Home",
		components: {
			TinymceEditor
		},
		data() {
			return {
				uploadUrl: "https://zyjwsys.sxsla.cn/files/upload",
				user: JSON.parse(sessionStorage.getItem('CurUser')),
				rowCenter: {
					"text-align": "center"
				},
				firstDialogVisible: false,
				firstData: [],
				firstform: {
					sub_title: "",
					sub_title1: "",
					title: "",
					title1: ""
				},
				secondDialogVisible: false,
				secondTitle: [{
						"title": "左上角标题(中文)",
						"content": "",
						"contentType": 1
					}, {
						"title": "左上角标题(英文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "内容(中文)",
						"content": "",
						"contentType": 1
					}, {
						"title": "内容(英文)",
						"content": "",
						"contentType": 1
					}
				],
				secondform: {

				},
				secondImageUrl: ["https://xlhzfile.sxsla.cn/files/2z1e0igo.png"],
				secondData: [],
				thirdDialogVisible: false,
				thirdTitle: [{
						"title": "标题(中文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "标题(英文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "内容(中文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "内容(英文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "标题1(中文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "标题1(英文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "内容1(中文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "内容1(英文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "标题2(中文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "标题2(英文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "内容2(中文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "内容2(英文)",
						"content": "",
						"contentType": 1
					}
				],
				thirdData: [],
				thirdform: {},
				fourthDialogVisible: false,
				fourthTitle: [{
						"title": "标题(中文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "标题(英文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "内容(中文)",
						"content": "",
						"contentType": 1
					},
					{
						"title": "内容(英文)",
						"content": "",
						"contentType": 1
					},
					// {
					// 	"title": "标题1(中文)",
					// 	"content": "",
					// 	"contentType": 1
					// },
					// {
					// 	"title": "标题1(英文)",
					// 	"content": "",
					// 	"contentType": 1
					// },
					// {
					// 	"title": "内容1(中文)",
					// 	"content": "",
					// 	"contentType": 1
					// },
					// {
					// 	"title": "内容1(英文)",
					// 	"content": "",
					// 	"contentType": 1
					// },
					// {
					// 	"title": "标题2(中文)",
					// 	"content": "",
					// 	"contentType": 1
					// },
					// {
					// 	"title": "标题2(英文)",
					// 	"content": "",
					// 	"contentType": 1
					// },
					// {
					// 	"title": "内容2(中文)",
					// 	"content": "",
					// 	"contentType": 1
					// },
					// {
					// 	"title": "内容2(英文)",
					// 	"content": "",
					// 	"contentType": 1
					// },
					// {
					// 	"title": "标题3(中文)",
					// 	"content": "",
					// 	"contentType": 1
					// },
					// {
					// 	"title": "标题3(英文)",
					// 	"content": "",
					// 	"contentType": 1
					// },
					// {
					// 	"title": "内容3(中文)",
					// 	"content": "",
					// 	"contentType": 1
					// },
					// {
					// 	"title": "内容3(英文)",
					// 	"content": "",
					// 	"contentType": 1
					// }
				],
				fourthData:[],
				fourthform: {
					title: "",
					content: "",
					btn: ""
				},
				btnText: "提 交",
			}
		},
		beforeMount() {
			this.secondData = [];

			for (var i = 0; i < this.secondTitle.length; i++) {
				if (i % 2 != 0) {
					var bean = {
						id: "",
						title: "second_title" + (i + 1),
						content: "",
						contentType: this.secondTitle[i].contentType,
						contentEg: "",
						type: "chanping_home_second"
					}
					this.secondData.push(bean);
				}
				this.$set(this.secondform, 'title' + (i + 1), '');
			}

			for (var i = 0; i < this.thirdTitle.length; i++) {
				if (i % 2 != 0) {
					var bean = {
						id: "",
						title: "chanping_home_third_title" + (i + 1),
						content: "",
						contentType: this.thirdTitle[i].contentType,
						contentEg: "",
						type: "chanping_home_third"
					}
					this.thirdData.push(bean);
				}
				this.$set(this.thirdform, 'title' + (i + 1), '');
			}
			
			for (var i = 0; i < this.fourthTitle.length; i++) {
				if (i % 2 != 0) {
					var bean = {
						id: "",
						title: "chanping_home_fourth_title" + (i + 1),
						content: "",
						contentType: this.fourthTitle[i].contentType,
						contentEg: "",
						type: "chanping_home_fourth"
					}
					this.fourthData.push(bean);
				}
				this.$set(this.fourthform, 'title' + (i + 1), '');
			}                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         
			

			// console.log("11--" + JSON.stringify(this.secondData));
			this.getData();
		},
		computed: {
			// 初始化富文本
			initEditor() {
				return {
					height: 300,
					branding: false,
					skin_url: '/tinymce/skins/ui/oxide',
					content_css: '/tinymce/skins/content/default/content.css',
					language_url: '/tinymce/langs/zh_CN.js',
					language: 'zh_CN',
					plugins: 'code print preview fullscreen paste searchreplace save autosave link autolink image imagetools media table codesample lists advlist hr charmap emoticons anchor directionality pagebreak quickbars nonbreaking visualblocks visualchars wordcount',
					toolbar: 'fullscreen preview code | undo redo | forecolor backcolor | bold italic underline strikethrough | alignleft aligncenter alignright alignjustify | outdent indent | numlist bullist | formatselect fontselect fontsizeselect | link image media emoticons charmap anchor pagebreak codesample | ltr rtl',
					toolbar_drawer: 'sliding',
					fontsize_formats: '8px 10px 12px 14px 18px 24px 36px 48px 60px 72px 80px 90px 100px 110px 120px 140px 180px',
					images_upload_handler: (blobInfo, success, error) => {
						let file = blobInfo.blob();
						// 使用axios上传
						const formData = new FormData();
						formData.append('file', file, file.name);
						this.$http.post('https://zyjwsys.sxsla.cn/files/upload', formData).then(res => {
							if (res.data.code == 0) {
								success(res.data.data);
							} else {
								error(res.data.msg);
							}
						}).catch(e => {
							console.error(e);
							error(e.message);
						});
					},
					file_picker_types: 'media',
					file_picker_callback: () => {}
				}
			}
		},

		methods: {

			save(type) {
				var that = this;
				if (type == 1) {
					var params = [{
						id: this.firstData[0].id,
						title: "sub_title",
						content: this.firstform.sub_title,
						contentEg: this.firstform.sub_title1,
						type: "chanping_home_first"
					}, {
						id: this.firstData[1].id,
						title: "title",
						content: this.firstform.title,
						contentEg: this.firstform.title1,
						type: "chanping_home_first"
					}];
					this.utils.requestPost(this, "/content/add", params, function(res, total) {
						that.utils.showMessage("success", "保存成功");
						that.firstDialogVisible = false;
						that.getData();
					});
				} else if (type == 2) {
					for (var i = 0; i < this.secondData.length; i++) {
						var bean = this.secondData[i];
						var j = i * 2;
						bean.content = this.secondTitle[j].content;
						bean.contentEg = this.secondTitle[j + 1].content;
						bean.id = this.secondTitle[j].id;
					}
					// console.log("22---" + JSON.stringify(this.secondData))
					this.utils.requestPost(this, "/content/add", this.secondData, function(res, total) {
						that.utils.showMessage("success", "保存成功");
						that.secondDialogVisible = false;
						that.getData();
					});
				} else if (type == 3) {
					
					for (var i = 0; i < this.thirdData.length; i++) {
						var bean = this.thirdData[i];
						var j = i * 2;
						bean.content = this.thirdTitle[j].content;
						bean.contentEg = this.thirdTitle[j + 1].content;
						bean.id = this.thirdTitle[j].id;
					}
					this.utils.requestPost(this, "/content/add",  this.thirdData, function(res, total) {
						that.utils.showMessage("success", "保存成功");
						that.thirdDialogVisible = false;
						that.getData();
					});
				} else if (type == 4) {
					for (var i = 0; i < this.fourthData.length; i++) {
						var bean = this.fourthData[i];
						var j = i * 2;
						bean.content = this.fourthTitle[j].content;
						bean.contentEg = this.fourthTitle[j + 1].content;
						bean.id = this.fourthTitle[j].id;
					}
					this.utils.requestPost(this, "/content/add",  this.fourthData, function(res, total) {
						that.utils.showMessage("success", "保存成功");
						that.fourthDialogVisible = false;
						that.getData();
					});
				}  




			},
			eidt(type) {
				if (type == 1) {
					this.firstDialogVisible = true;
				} else if (type == 2) {
					this.secondDialogVisible = true;
				} else if (type == 3) {
					this.thirdDialogVisible = true;
				} else if (type == 4) {
					this.fourthDialogVisible = true;
				} 
			},
			getData() {
				var that = this;
				var params = {
					"param": {
						'type': 'chanping_home'
					}
				};

				this.utils.requestPost(this, '/content/getDataList', params, function(res, total) {
					that.firstData = [];
					var j = 0;
					var k = 0;
					var m = 0;
					for (var i = 0; i < res.length; i++) {
						var bean = res[i];
						if (bean.type == 'chanping_home_first' && bean.title == 'sub_title') {
							that.firstform.sub_title = bean.content
							that.firstform.sub_title1 = bean.contentEg
							that.firstData.push(bean);
						} else if (bean.type == 'chanping_home_first' && bean.title == 'title') {
							that.firstform.title = bean.content
							that.firstform.title1 = bean.contentEg
							that.firstData.push(bean);
						}else if (bean.type == 'chanping_home_second') {
							that.secondTitle[j].id = bean.id;
							that.secondTitle[j].content = bean.content;
							that.secondTitle[j + 1].id = bean.id;
							that.secondTitle[j + 1].content = bean.contentEg;
							j = j + 2;
						} else if (bean.type == 'chanping_home_third') {
							that.thirdTitle[k].id = bean.id;
							that.thirdTitle[k].content = bean.content;
							that.thirdTitle[k + 1].id = bean.id;
							that.thirdTitle[k + 1].content = bean.contentEg;
							k = k + 2;
						}else if (bean.type == 'chanping_home_fourth') {
							that.fourthTitle[m].id = bean.id;
							that.fourthTitle[m].content = bean.content;
							that.fourthTitle[m + 1].id = bean.id;
							that.fourthTitle[m + 1].content = bean.contentEg;
							m = m + 2;
						}


					}
				});



			},
			setImage(url) {
				this.secondImageUrl = [];
				this.secondImageUrl.push(url);
			},
			handleAvatarSuccess1(res, file, item) {
				// this.secondTitle[24].content = URL.createObjectURL(file.raw);
			},
			beforeAvatarUpload(file) {
				const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
				const isLt2M = file.size / 1024 / 1024 < 2;

				// if (!isJPG) {
				// 	this.$message.error('上传头像图片只能是 JPG 格式!');
				// }
				if (!isLt2M) {
					this.$message.error('上传图片大小不能超过 2MB!');
				}

				return isJPG && isLt2M;
			},
		}
	}
</script>

<style scoped>

</style>
